<template>
  <div
    v-if="showConfirmModal"
    class="fixed inset-0 flex items-center justify-center bg-black/80 z-[999] px-4 backdrop-blur-sm"
  >
    <!-- Spinner Overlay -->
    <div v-if="loading" class="flex items-center justify-center w-full h-full">
      <div class="twist-spinner w-[60px] h-[60px]"></div>
    </div>

    <!-- Modal Content -->
    <div
      v-else
      class="relative w-full max-w-md bg-[#14181F] border border-gray-800 p-8 rounded-[16px] shadow-[0_10px_40px_rgba(0,0,0,0.5)] text-center"
    >
      <!-- Title -->
      <h2 class="text-2xl sm:text-3xl font-black text-[#00F0FF] font-oxanium tracking-wide uppercase mb-4 mt-2">
        {{ $t('StoreConfirmationModal.Title') }}
      </h2>

      <!-- Confirmation Text -->
      <p class="text-[#B9CACB] text-sm sm:text-base leading-relaxed mb-6">
        {{ $t('StoreConfirmationModal.AreYouSure') }}
        <strong class="text-white">{{ productName }}</strong>
        {{ $t('StoreConfirmationModal.For') }}
        <strong class="text-[#00F0FF]">
          {{ requiredPoints }} {{ requiredPoints > 1 ? $t('StoreConfirmationModal.Points') : $t('StoreConfirmationModal.Point') }}
        </strong>?
      </p>

      <!-- Buttons -->
      <div class="flex w-full gap-4 mt-2">
        <!-- Confirm Button -->
        <button
          @click="$emit('confirmPurchase')"
          class="w-1/2 px-4 py-3 bg-[#00F0FF] text-black font-bold text-sm rounded-[10px] hover:bg-[#00d4e0] transition-colors uppercase tracking-wider"
          :disabled="loading"
        >
          {{ $t('StoreConfirmationModal.BuyNow') }}
        </button>

        <!-- Cancel Button -->
        <button
          @click="$emit('closeConfirmModal')"
          class="w-1/2 px-4 py-3 bg-[#0D0B10] border border-gray-800 text-[#B9CACB] font-bold text-sm rounded-[10px] hover:text-white hover:bg-gray-800/50 transition-colors uppercase tracking-wider"
          :disabled="loading"
        >
          {{ $t('StoreConfirmationModal.Cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showConfirmModal: Boolean,
    productName: String,
    requiredPoints: Number,
    loading: Boolean,
  },
};
</script>
